import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useMarketplace } from '../../context/MarketplaceContext';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseAnonKey);

interface MarketplaceOption {
  id: 'kiosk' | 'boutique' | 'restaurant';
  name: string;
  logo: string;
}

const storageBase = import.meta.env.VITE_SUPABASE_URL ? `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public` : '';
const marketplaceOptions: MarketplaceOption[] = [
  {
    id: 'kiosk',
    name: 'Kiosk',
    logo: `${storageBase}/Files/Logos/Kiosk.gif`
  },
  {
    id: 'boutique',
    name: 'Boutiques',
    logo: `${storageBase}/Files/Logos/Boutiques.png`
  },
  {
    id: 'restaurant',
    name: 'Restaurants',
    logo: `${storageBase}/Files/Logos/Restaurant.png`
  }
];

// Produits variés pour les carrousels - Boissons, Vêtements, Chaussures, Électronique, etc.
const productsCarousel1 = [
  // Boissons
  { id: 'drink-1', image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=600&auto=format&fit=crop' },
  { id: 'drink-2', image: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&auto=format&fit=crop' },
  { id: 'drink-3', image: 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=600&auto=format&fit=crop' },
  // Vêtements
  { id: 'clothes-1', image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=600&auto=format&fit=crop' },
  { id: 'clothes-2', image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&auto=format&fit=crop' },
  { id: 'clothes-3', image: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=600&auto=format&fit=crop' },
  // Chaussures
  { id: 'shoes-1', image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600&auto=format&fit=crop' },
  { id: 'shoes-2', image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=600&auto=format&fit=crop' },
  { id: 'shoes-3', image: 'https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=600&auto=format&fit=crop' },
  // Électronique
  { id: 'tech-1', image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&auto=format&fit=crop' },
  { id: 'tech-2', image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&auto=format&fit=crop' }
];

const productsCarousel2 = [
  // Accessoires
  { id: 'acc-1', image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=600&auto=format&fit=crop' },
  { id: 'acc-2', image: 'https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=600&auto=format&fit=crop' },
  // Cosmétiques
  { id: 'cosmetic-1', image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=600&auto=format&fit=crop' },
  { id: 'cosmetic-2', image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=600&auto=format&fit=crop' },
  // Alimentation
  { id: 'food-1', image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&auto=format&fit=crop' },
  { id: 'food-2', image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&auto=format&fit=crop' },
  // Sport
  { id: 'sport-1', image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&auto=format&fit=crop' },
  { id: 'sport-2', image: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=600&auto=format&fit=crop' },
  // Maison & Déco
  { id: 'home-1', image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&auto=format&fit=crop' },
  { id: 'home-2', image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600&auto=format&fit=crop' },
  // Livres
  { id: 'book-1', image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=600&auto=format&fit=crop' },
  { id: 'book-2', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&auto=format&fit=crop' }
];

const productsCarousel3 = [
  // Bijoux
  { id: 'jewelry-1', image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&auto=format&fit=crop' },
  { id: 'jewelry-2', image: 'https://images.unsplash.com/photo-1603561596112-67d44e7c3988?w=600&auto=format&fit=crop' },
  // Montres
  { id: 'watch-1', image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&auto=format&fit=crop' },
  { id: 'watch-2', image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?w=600&auto=format&fit=crop' },
  // Sacs
  { id: 'bag-1', image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600&auto=format&fit=crop' },
  { id: 'bag-2', image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600&auto=format&fit=crop' },
  // Parfums
  { id: 'perfume-1', image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=600&auto=format&fit=crop' },
  { id: 'perfume-2', image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=600&auto=format&fit=crop' },
  // Jouets
  { id: 'toy-1', image: 'https://images.unsplash.com/photo-1553456558-aff63285bdd1?w=600&auto=format&fit=crop' },
  { id: 'toy-2', image: 'https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?w=600&auto=format&fit=crop' },
  // Instruments
  { id: 'music-1', image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&auto=format&fit=crop' },
  { id: 'music-2', image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=600&auto=format&fit=crop' }
];

export function HeroSearchSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { marketplaceType } = useMarketplace();
  const [logos, setLogos] = useState<Record<string, string>>({});
  const currentOption = marketplaceOptions.find(opt => opt.id === marketplaceType) || marketplaceOptions[0];

  useEffect(() => {
    async function loadLogos() {
      try {
        const { data } = await supabase
          .from('miniapps')
          .select('name, logo')
          .in('name', ['Kiosk', 'Boutiques', 'Restaurants']);

        if (data) {
          const logoMap: Record<string, string> = {};
          data.forEach((app) => {
            const key = app.name.toLowerCase();
            if (key === 'kiosk') logoMap['kiosk'] = app.logo;
            else if (key === 'boutiques') logoMap['boutique'] = app.logo;
            else if (key === 'restaurants') logoMap['restaurant'] = app.logo;
          });
          setLogos(logoMap);
        }
      } catch (error) {
        console.error('Error loading logos:', error);
      }
    }
    loadLogos();
  }, []);

  const getLogo = (id: string) => {
    return logos[id] || marketplaceOptions.find(opt => opt.id === id)?.logo || '';
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  // Dupliquer les produits pour les carrousels infinis
  const carouselProducts1 = [...productsCarousel1, ...productsCarousel1, ...productsCarousel1];
  const carouselProducts2 = [...productsCarousel2, ...productsCarousel2, ...productsCarousel2];
  const carouselProducts3 = [...productsCarousel3, ...productsCarousel3, ...productsCarousel3];

  return (
    <section className="relative min-h-[600px] overflow-hidden bg-gradient-to-br from-neutral-50 via-white to-neutral-100 dark:from-neutral-900 dark:via-neutral-800 dark:to-neutral-900">
      {/* Layout en deux colonnes : gauche pour carrousels, droite pour grid */}
      <div className="absolute inset-0 z-0 flex">
        {/* Section gauche : Carrousels */}
        <div className="relative flex-1 h-full overflow-hidden">
        {/* Premier carrousel - en haut */}
        <div className="absolute left-0 top-0 h-[32%] w-full overflow-x-clip overflow-y-visible py-2">
          <ul className="flex animate-carousel gap-4">
            {carouselProducts1.map((product, i) => (
              <li
                key={`carousel-1-${product.id}-${i}`}
                className="relative aspect-square h-full w-[140px] flex-none sm:w-[160px] md:w-[180px]"
              >
                <div className="group relative h-full w-full overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm transition-all duration-300 hover:border-blue-400 hover:shadow-md dark:border-neutral-700 dark:bg-neutral-800">
                  <img
                    src={product.image}
                    alt=""
                    className="h-full w-full object-cover transition-transform duration-500 ease-out will-change-transform group-hover:scale-105"
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
        {/* Deuxième carrousel - au milieu */}
        <div className="absolute left-0 top-[34%] h-[32%] w-full overflow-x-clip overflow-y-visible py-2">
          <ul className="flex animate-carousel-reverse gap-4">
            {carouselProducts2.map((product, i) => (
              <li
                key={`carousel-2-${product.id}-${i}`}
                className="relative aspect-square h-full w-[140px] flex-none sm:w-[160px] md:w-[180px]"
              >
                <div className="group relative h-full w-full overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm transition-all duration-300 hover:border-blue-400 hover:shadow-md dark:border-neutral-700 dark:bg-neutral-800">
                  <img
                    src={product.image}
                    alt=""
                    className="h-full w-full object-cover transition-transform duration-500 ease-out will-change-transform group-hover:scale-105"
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
        {/* Troisième carrousel - en bas */}
        <div className="absolute left-0 bottom-0 h-[32%] w-full overflow-x-clip overflow-y-visible pt-2 pb-4">
          <ul className="flex animate-carousel gap-4">
            {carouselProducts3.map((product, i) => (
              <li
                key={`carousel-3-${product.id}-${i}`}
                className="relative aspect-square h-full w-[140px] flex-none sm:w-[160px] md:w-[180px]"
              >
                <div className="group relative h-full w-full overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm transition-all duration-300 hover:border-blue-400 hover:shadow-md dark:border-neutral-700 dark:bg-neutral-800">
                  <img
                    src={product.image}
                    alt=""
                    className="h-full w-full object-cover transition-transform duration-500 ease-out will-change-transform group-hover:scale-105"
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Gradient de disparition progressive à droite */}
        <div 
          className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
          style={{
            background: 'linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.95) 100%)'
          }}
        />
        </div>

        {/* Section droite : Grid de 4 images promotionnelles */}
        <div className="relative w-[600px] h-full p-4 flex items-center justify-end pr-8">
          <div className="grid grid-cols-2 gap-4 w-full max-w-[560px] h-full max-h-[700px]">
            <div className="relative overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:border-neutral-700 dark:bg-neutral-800">
              <img
                src="/assets/images/dee_blvckon IG.jpeg"
                alt="Promotion 1"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="relative overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:border-neutral-700 dark:bg-neutral-800">
              <img
                src="/assets/images/plusone_usa.jpeg"
                alt="Promotion 2"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="relative overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:border-neutral-700 dark:bg-neutral-800">
              <img
                src="/assets/images/télécharger (47).jpeg"
                alt="Promotion 3"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="relative overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:border-neutral-700 dark:bg-neutral-800">
              <img
                src="/assets/images/free2.png"
                alt="Promotion 4"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Overlay de flou progressif autour du logo et de la barre de recherche */}
      <div 
        className="absolute inset-0 z-[5] pointer-events-none"
        style={{
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          maskImage: 'radial-gradient(ellipse 1000px 600px at 50% 45%, black 0%, black 25%, rgba(0,0,0,0.7) 40%, rgba(0,0,0,0.3) 60%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(ellipse 1000px 600px at 50% 45%, black 0%, black 25%, rgba(0,0,0,0.7) 40%, rgba(0,0,0,0.3) 60%, transparent 100%)'
        }}
      />

      {/* Contenu principal */}
      <div className="relative z-10 flex min-h-[600px] flex-col items-center justify-center px-4 py-16">
        {/* Logo agrandi centré au-dessus de la barre de recherche */}
        <div className="mb-12 flex items-center justify-center relative z-20">
          <div className="relative">
            {/* Gradient dégradé autour du logo */}
            <div className="absolute inset-0 -z-10 rounded-full bg-gradient-to-r from-blue-400/30 via-purple-400/30 to-pink-400/30 blur-2xl animate-pulse" />
            <div className="absolute inset-0 -z-10 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20 blur-xl" />
            <div className="h-20 w-auto md:h-28">
              <img
                src="/assets/images/Shoplinkpng.png"
                alt="ShopLink Logo"
                className="h-full w-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>

        {/* Barre de recherche moderne */}
        <form onSubmit={handleSearch} className="w-full max-w-3xl relative z-20">
          <div className="relative p-1.5 rounded-full bg-white/40 backdrop-blur-xl border border-white/20 shadow-lg">
            {/* Container blanc (contenu dans le padding) */}
            <div className="relative rounded-full bg-white">
              <div className="relative flex items-center">
                <div className="absolute left-5 z-10">
                  <MagnifyingGlassIcon className="h-6 w-6 text-neutral-400 transition-colors duration-200 group-focus-within:text-blue-500" />
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Rechercher des produits, boutiques..."
                  className="relative z-10 w-full rounded-full border-0 bg-transparent px-14 pr-32 py-5 text-lg text-neutral-700 placeholder:text-neutral-400 focus:outline-none focus:ring-0 dark:text-neutral-200 dark:placeholder-neutral-500"
                />
                {/* Marketplace sélectionné à droite */}
                <div className="absolute right-3 z-10 flex items-center gap-2 rounded-full bg-neutral-50 px-3 py-2 border border-neutral-200 dark:bg-neutral-800 dark:border-neutral-700">
                  <div className="relative h-5 w-5 flex-shrink-0 overflow-hidden rounded">
                    <img
                      src={getLogo(marketplaceType)}
                      alt={currentOption.name}
                      className="h-full w-full object-contain"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.style.display = 'none';
                      }}
                    />
                  </div>
                  <span className="text-sm font-medium text-neutral-700 dark:text-neutral-200 hidden sm:inline">
                    {currentOption.name}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Bannière défilante avec logos Burok */}
      <div className="relative w-full overflow-hidden bg-gradient-to-r from-[#ff0442] via-[#ff1a4d] to-[#ff0442] py-3">
        <div className="flex animate-scroll-left items-center gap-8 whitespace-nowrap">
          {/* Dupliquer les logos pour un défilement infini */}
          {[
            '/assets/BurokLogoModern/BurokModernLogoWhite.png',
            '/assets/BurokLogoModern/BurokModernLogoBlack.png',
            '/assets/BurokLogoModern/BurokModernLogoOrange.png',
            '/assets/BurokLogoModern/BurokModernLogoPurple.png',
            '/assets/BurokLogoModern/BurokModernLogoBlue.png',
            '/assets/BurokLogoModern/BurokModernLogoYellow.png',
            '/assets/BurokLogoModern/BurokModernLogoGreen.png',
            '/assets/BurokLogoModern/BurokModernLogoRed.png',
            '/assets/BurokLogoModern/BurokModernLogoWhite.png',
            '/assets/BurokLogoModern/BurokModernLogoBlack.png',
            '/assets/BurokLogoModern/BurokModernLogoOrange.png',
            '/assets/BurokLogoModern/BurokModernLogoPurple.png',
            '/assets/BurokLogoModern/BurokModernLogoBlue.png',
            '/assets/BurokLogoModern/BurokModernLogoYellow.png',
            '/assets/BurokLogoModern/BurokModernLogoGreen.png',
            '/assets/BurokLogoModern/BurokModernLogoRed.png',
          ].map((logo, index) => (
            <div key={`logo-1-${index}`} className="flex-shrink-0">
              <img
                src={logo}
                alt={`Burok Logo ${index + 1}`}
                className="h-6 w-auto object-contain opacity-90 transition-opacity duration-300 hover:opacity-100 sm:h-8 md:h-10"
              />
            </div>
          ))}
          {/* Dupliquer pour un défilement continu */}
          {[
            '/assets/BurokLogoModern/BurokModernLogoWhite.png',
            '/assets/BurokLogoModern/BurokModernLogoBlack.png',
            '/assets/BurokLogoModern/BurokModernLogoOrange.png',
            '/assets/BurokLogoModern/BurokModernLogoPurple.png',
            '/assets/BurokLogoModern/BurokModernLogoBlue.png',
            '/assets/BurokLogoModern/BurokModernLogoYellow.png',
            '/assets/BurokLogoModern/BurokModernLogoGreen.png',
            '/assets/BurokLogoModern/BurokModernLogoRed.png',
          ].map((logo, index) => (
            <div key={`logo-2-${index}`} className="flex-shrink-0">
              <img
                src={logo}
                alt={`Burok Logo ${index + 1}`}
                className="h-6 w-auto object-contain opacity-90 transition-opacity duration-300 hover:opacity-100 sm:h-8 md:h-10"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

